import { render, staticRenderFns } from "./PrimaryMenuConfiguration.vue?vue&type=template&id=d5f80932&scoped=true"
import script from "./PrimaryMenuConfiguration.vue?vue&type=script&lang=js"
export * from "./PrimaryMenuConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PrimaryMenuConfiguration.vue?vue&type=style&index=0&id=d5f80932&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f80932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f80932')) {
      api.createRecord('d5f80932', component.options)
    } else {
      api.reload('d5f80932', component.options)
    }
    module.hot.accept("./PrimaryMenuConfiguration.vue?vue&type=template&id=d5f80932&scoped=true", function () {
      api.rerender('d5f80932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/PrimaryMenuConfiguration.vue"
export default component.exports